// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@conklin/App/SharedStyles/CartLineSharedStyles";
import { CartLineCardExpandedStyles } from "@conklin/Overrides/Components/CartLineCardExpanded";
import { xScreen } from "@conklin/XDL/Utilities";
import { productListStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsProductList";
import { css } from "styled-components";

productListStyles.orderLinesList = {
    cardExpanded: {
        extendedUnitNetPrice: {
            ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
        },
        cartLineContainer: {
            notes: {
                css: css`
                    ${xScreen("lte", "md")} {
                        grid-row: 6 / 7;
                    }
                `,
            },
        },
    } as CartLineCardExpandedStyles,
};
